import { render, staticRenderFns } from "./UnauthorizedView.vue?vue&type=template&id=513761c4"
import script from "./UnauthorizedView.vue?vue&type=script&lang=ts"
export * from "./UnauthorizedView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports